export function toCurrency(value: string | number): string {
  return parseInt(
      typeof value === "number" ? value.toString() : value
    ).toLocaleString("ja-JP")
  //    {
  //   style: "currency",
  //   currency: "JPY",
  // })
}
